import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_URL } from '../config/api';

const Unsubscribe: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error' | 'already'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const email = searchParams.get('email');
    const token = searchParams.get('token');
    const campaign = searchParams.get('campaign');

    if (!email || !token) {
      setStatus('error');
      setMessage('Invalid unsubscribe link. Missing email or verification token.');
      return;
    }

    processUnsubscribe(email, token, campaign || '');
  }, [searchParams]);

  const processUnsubscribe = async (email: string, token: string, campaign: string) => {
    try {
      const response = await fetch(
        `${API_URL}/api/newsletter/unsubscribe?email=${encodeURIComponent(email)}&token=${token}&campaign=${campaign}`
      );

      const data = await response.json();

      if (response.ok) {
        if (data.alreadyUnsubscribed) {
          setStatus('already');
          setMessage('You are already unsubscribed from our mailing list.');
        } else {
          setStatus('success');
          setMessage('You have been successfully unsubscribed from our mailing list.');
        }
      } else {
        setStatus('error');
        setMessage(data.error || 'Failed to process unsubscribe request.');
      }
    } catch (error) {
      console.error('Unsubscribe error:', error);
      setStatus('error');
      setMessage('An error occurred while processing your request. Please try again later.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '48px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ marginBottom: '24px' }}>
          <img
            src="https://ssembleshortsbucket.blob.core.windows.net/web-assets/dstribute-logo.png"
            alt="Ssemble"
            style={{ height: '40px' }}
          />
        </div>

        {status === 'loading' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '16px'
            }}>
              ⏳
            </div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a1a1a',
              marginBottom: '12px'
            }}>
              Processing...
            </h1>
            <p style={{
              color: '#666',
              fontSize: '16px'
            }}>
              Please wait while we process your request.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '16px'
            }}>
              ✅
            </div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#28a745',
              marginBottom: '12px'
            }}>
              Unsubscribed Successfully
            </h1>
            <p style={{
              color: '#666',
              fontSize: '16px'
            }}>
              {message}
            </p>
            <p style={{
              color: '#999',
              fontSize: '14px',
              marginTop: '24px'
            }}>
              You will no longer receive marketing emails from Ssemble.
            </p>
          </>
        )}

        {status === 'already' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '16px'
            }}>
              ℹ️
            </div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#17a2b8',
              marginBottom: '12px'
            }}>
              Already Unsubscribed
            </h1>
            <p style={{
              color: '#666',
              fontSize: '16px'
            }}>
              {message}
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              fontSize: '48px',
              marginBottom: '16px'
            }}>
              ❌
            </div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#dc3545',
              marginBottom: '12px'
            }}>
              Unsubscribe Failed
            </h1>
            <p style={{
              color: '#666',
              fontSize: '16px'
            }}>
              {message}
            </p>
            <p style={{
              color: '#999',
              fontSize: '14px',
              marginTop: '24px'
            }}>
              If you continue to have issues, please contact support@ssemble.com
            </p>
          </>
        )}

        <div style={{
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #eee'
        }}>
          <a
            href="https://ssemble.com"
            style={{
              color: '#ff4000',
              textDecoration: 'none',
              fontSize: '14px'
            }}
          >
            Visit Ssemble.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
